import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Home as HomeIcon, Search as SearchIcon, Award, LogOut } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";
import { useUser } from "../contexts/UserContext";
import { Button } from "./ui/button";

const Logo = ({ side }) => (
 <div
 data-testid={`steadfast-logo-${side}`}
 className="flex items-center gap-2 select-none"
 >
 <img
 src="/steadfast-logo.png"
 alt="Steadfast IT Consulting"
 className="w-10 h-10 object-contain "
 draggable={false}
 />
 <div className="hidden sm:block leading-tight">
 <div className="font-heading font-black text-[13px] tracking-tight text-zinc-900 ">
 STEADFAST
 </div>
 <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 ">
 IT Consulting
 </div>
 </div>
 </div>
);

const Header = ({ showNav = true }) => {
 const { theme, toggle } = useTheme();
 const { user, logout } = useUser();
 const navigate = useNavigate();
 const location = useLocation();
 const [query, setQuery] = useState("");

 const handleSearch = (e) => {
 e.preventDefault();
 if (query.trim()) navigate(`/search?q=${encodeURIComponent(query.trim())}`);
 };

 return (
 <header
 data-testid="app-header"
 className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-zinc-200 "
 >
 <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between gap-4">
 <Logo side="left" />

 {showNav && user && (
 <nav className="hidden md:flex items-center gap-1">
 <Link
 to="/home"
 data-testid="nav-home-btn"
 className={`px-3 py-2 rounded-sm text-sm font-medium transition-colors ${location.pathname === "/home"
 ? "bg-zinc-900 text-white "
 : "text-zinc-700 hover:bg-zinc-100 :bg-zinc-900"
 }`}
 >
 <HomeIcon className="inline w-4 h-4 mr-1.5 -mt-0.5" />
 Home
 </Link>
 </nav>
 )}

 <div className="flex items-center gap-2 flex-1 md:flex-initial justify-end">
 {showNav && user && (
 <form onSubmit={handleSearch} className="hidden md:block relative">
 <SearchIcon className="w-4 h-4 text-zinc-400 absolute left-3 top-1/2 -translate-y-1/2" />
 <input
 data-testid="global-search-input"
 type="text"
 placeholder="Search topics…"
 value={query}
 onChange={(e) => setQuery(e.target.value)}
 className="pl-9 pr-3 py-2 w-56 text-sm rounded-sm border border-zinc-200 bg-white text-zinc-900 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
 />
 </form>
 )}
 <Logo side="right" />
 </div>
 </div>
 </header>
 );
};

export default Header;
